const sentryDsnRegex = /^https:\/\/[a-f0-9]{32}@[a-z0-9]{7}\.ingest\.sentry\.io\/[0-9]+$/;

const hasProp = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

const logLevels = {
  error: 0,
  warn: 1,
  info: 2,
  debug: 3
};

const isString = (data) => typeof data === 'string';
const isLogLevelString = (data) => isString(data) && data.length > 0 && hasProp(logLevels, data);

const isObject = (data) => data instanceof Object && data.constructor === Object;
const isObjectWithEntry = (data) => isObject(data) && Object.entries(data).length > 0;

/* eslint-disable-next-line no-undef */
const isEvent = (data) => (data instanceof Event || data.constructor.name === 'Event') && isString(data.type);
const isLogEvent = (data) => {
  return (
    isEvent(data) &&
    /^log(error|warn|info|debug)$/.test(data.type) &&
    isObjectWithEntry(data.detail) &&
    isLogLevelString(data.detail.level)
  );
};

const isSentryDsn = (data) => isString(data) && sentryDsnRegex.test(data);

export {
  hasProp,
  isEvent,
  isLogEvent,
  isLogLevelString,
  isObject,
  isObjectWithEntry,
  isSentryDsn,
  isString
};
